import * as types from './types';

const getFeatures = postingId => {
  return {
    type: types.GET_FORM_VALUES,
    meta: {
      async: true,
      blocking: false,
      api: 'publicadorProf',
      path: `/publication/api/v1/posting/STEP_MAIN/${postingId}`,
      method: 'GET'
    }
  };
};

const updateFormValues = newFormValues => {
  return {
    type: types.UDPATE_FORMVALUES,
    payload: newFormValues
  };
};

const updateAntiquityType = antiquityType => {
  return {
    type: types.SET_ANTIQUITY_TYPE,
    payload: antiquityType
  };
};

const updateUnitMeasurement = (unitToUpdate, value) => {
  return {
    type: types.UPDATE_UNIT_MEASUREMENT,
    payload: {
      unitToUpdate,
      value
    }
  };
};

const resetInfo = () => ({
  type: types.RESET_INFO
});

export { getFeatures, updateFormValues, updateUnitMeasurement, updateAntiquityType, resetInfo };
